import React from 'react';
import { NewModal } from 'lib/components';
import { Gap } from 'lib/components/styles/layout';
import { Formik, Form, useFormikContext } from 'formik';
import { ParagraphNormal } from 'lib/components/styles/typography';
import { Button } from 'react-covideo-common';
import { useDeleteUIKitMutation } from 'lib/api/superadmin/uikits/useDeleteUIKitMutation';
import { IUIKitsQueryParams } from 'lib/api/superadmin/uikits/useQueryUIKits';
import { ILandingPageBuilderForm } from '../../../types';

interface IProps {
  id: number;
  closeModalHandler: () => void;
  params: IUIKitsQueryParams;
  remove: <X = any>(index: number) => X | undefined;
}

export const DeleteUIKitModal = ({
  id,
  closeModalHandler,
  params,
  remove,
}: IProps) => {
  const { values } = useFormikContext<ILandingPageBuilderForm>();
  const { mutateAsync, isLoading } = useDeleteUIKitMutation({
    closeModalHandler,
    params,
  });
  const onSubmitHandler = async () => {
    const data = await mutateAsync(id);
    const idx = values.uiKits.findIndex(kit => kit.id === id);

    if (data && idx !== -1) {
      remove(idx);
    }
  };

  return (
    <NewModal
      headerText='You are about to delete a UI Kit'
      closeModal={closeModalHandler}
      style={{
        content: { width: 592, maxWidth: 592 },
      }}
    >
      <Formik initialValues={{ id }} onSubmit={onSubmitHandler}>
        {({ handleSubmit }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Gap
                flexDirection='column'
                justifyContent='flex-start'
                alignItems='flex-start'
                m='0 0 16px 0'
              >
                <ParagraphNormal>
                  Are you sure you want to delete this UI Kit?
                </ParagraphNormal>
              </Gap>

              <Gap
                m='32px 0 0 0'
                alignItems='center'
                justifyContent='flex-end'
                gap='12px'
              >
                <Button
                  disabled={isLoading}
                  text={isLoading ? 'Deleting...' : 'Delete UI Kit'}
                  variant='primary'
                  type='submit'
                />
              </Gap>
            </Form>
          );
        }}
      </Formik>
    </NewModal>
  );
};
